export const MAIN_SITE_URL = 'https://pacificlinkinternational.com'
export const EDUCATION_SITE_URL = 'https://education.pacificlinkinternational.com'
export const EDUCATION_HOST = 'education.pacificlinkinternational.com'

const EDUCATION_PATH = /^(?:\/(?:cn|ru|ar|ko))?\/education(?=$|\/)([\s\S]*)$/

export function isEducationHost(): boolean {
  if (import.meta.env.VITE_EDUCATION_HOST === 'true') return true
  if (typeof window === 'undefined') return false
  return window.location.hostname === EDUCATION_HOST
}

/** Formal main-site hosts should send /education to the education subdomain. */
export function shouldRedirectEducationToSubdomain(): boolean {
  if (isEducationHost() || typeof window === 'undefined') return false
  const host = window.location.hostname
  return host === 'pacificlinkinternational.com' || host === 'www.pacificlinkinternational.com'
}

/**
 * Public path on the education host.
 * `/education/programs` and `/cn/education/programs` both become `/programs`.
 * Returns null when the path is not an education URL.
 */
export function educationPublicPath(pathname: string): string | null {
  const match = pathname.match(EDUCATION_PATH)
  if (!match) return null
  const rest = match[1]
  if (!rest || rest === '/') return '/'
  return rest
}

/** Keep JSON links working on both the /education dev paths and the education host. */
export function educationAppPath(path: string): string {
  if (!isEducationHost()) return path
  const hashIndex = path.indexOf('#')
  const pathname = hashIndex >= 0 ? path.slice(0, hashIndex) : path
  const hash = hashIndex >= 0 ? path.slice(hashIndex) : ''
  const next = educationPublicPath(pathname)
  if (!next) return path
  return `${next}${hash}`
}
